const ImgFluid = ({ src, alt, lazy }) => {
    return (
        <img src={src} alt={alt || ""} style={{ width: '100%', height: 'auto' }}
            loading={lazy === false ? "eager" : "lazy"} />
    )
}

export default ImgFluid;